/* eslint-disable max-len */
const { default: axios } = require("axios");
const GlobalVariables = require("./globalVariables"); // Import the necessary module

class VoiceModel {
  static getEndpoints() {
    return {
      textToVoice: "/text_to_voice",
      textToVoiceGoogle: "/api/ai-voice/text-to-voice",
    };
  }
  /**
   * Sends a POST request to the text-to-voice API endpoint to convert a given text response into a voice response.
   *
   * @param {string} fullResponse - The text response to be converted into voice.
   * @returns {Promise<Blob>} A promise that resolves to a Blob containing the voice response.
   * @throws {Error} If the API request fails or the response is not successful.
   */
  static async getVoice(fullResponse) {
    const url =
      GlobalVariables.getGmailAPIURL() + VoiceModel.getEndpoints().textToVoice;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "API-Key": process.env.API_KEY,
      },
      body: JSON.stringify({ query: fullResponse }),
    });

    if (!response.ok) {
      throw new Error("Failed to get voice response");
    } else {
      return response.blob();
    }
  }

  /**
   * Sends a text input to the Google Text-to-Speech API and retrieves the voice response as a Blob.
   *
   * @param {string} fullResponse - The text input to be converted into speech.
   * @returns {Promise<Blob>} A promise that resolves to a Blob containing the voice response.
   * @throws {Error} If the API request fails or the response is not successful.
   */
  static async getVoiceGoogle(fullResponse) {
    const url =
      GlobalVariables.getAPIURL() + VoiceModel.getEndpoints().textToVoiceGoogle;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ text: fullResponse }),
    });

    if (!response.ok) {
      throw new Error("Failed to get voice response");
    } else {
      return response.blob();
    }
  }
}

module.exports = VoiceModel;
